module.exports = __webpack_public_path__ + "img/technical-team.11265e55.svg";